import HookBuilder from '@/hooks/HookBuilder';
import { UserService } from '@/services/users';

export const useUsers = HookBuilder.searchParamsHook(['users'], UserService.search, {
  errorMessage: 'There was an error while loading the users',
});

export const useUser = HookBuilder.getByIdHook(['user'], UserService.findById, {
  errorMessage: 'There was an error fetching the user',
});

export const useMe = HookBuilder.noParamsHook(['me'], UserService.me, {
  errorMessage: 'There was an error fetching the logged user information',
});
